<template>
  <div class="field">
    <label>
      {{ $t('search.label') }}
    </label>
    <div class="ui fluid action input">
      <input
        type="text"
        :placeholder="placeholder"
        :value="''"
        @input="$emit('input', $event.target.value.trim())">
      <button
        @click.prevent="$emit('run-search')"
        class="ui primary icon button">
        <i class="search icon"/>
      </button>
      <button
        @click.prevent="$emit('refresh-items')"
        type="button"
        class="ui primary basic icon button">
        <i class="redo alternate icon"/>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchBar',
  props: {
    placeholder: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
